import React from 'react'

/* ─────────────────────────────────────────────────────────────
   About Us
   Per brief:
   - Accessible from sidebar within same page experience
   - Copy provided separately — using placeholder copy for now,
     replace the text content when client provides final copy
   - No social sharing, no comment sections
───────────────────────────────────────────────────────────── */

/* Replace these with final client-approved copy */
const ABOUT_SECTIONS = [
  {
    id: 'who',
    label: 'Who We Are',
    body: `Mwuïlu is a private facilitation bureau operating at the intersection of diplomacy, discretion, and excellence. We serve a carefully selected circle of embassies, consulates general, permanent missions, international organisations, and private clients of the highest standing.

We do not advertise. We do not aggregate. We do not share. Every arrangement is handled personally, with full attention and complete confidentiality.`,
  },
  {
    id: 'what',
    label: 'What We Do',
    body: `Mwuïlu is a private facilitation company based in Belgium. We serve a carefully selected circle of embassies, consulates general, permanent missions, international organisations, and private clients whose affairs demand the highest standard of care.

Every arrangement is handled personally. Every detail is attended to with complete attention. Every confidence is kept without exception.

This is not a service we provide. It is simply how we work.`,
  },
  {
    id: 'how',
    label: 'How We Work',
    body: `We arrange what matters most when time and discretion are non-negotiable. Flight arrangements, partner hotels, ground transfers, and airport coordination are handled from first contact to final confirmation by our team, not by an algorithm.

Our partners are selected for quality, reliability, and their understanding of the level of service our members expect. No third-party aggregators. No automated booking. Every detail, personally managed.

A request submitted through this portal reaches our team within minutes. We access the best available options across all cabin classes and present a curated proposal within the hour.

Payment is arranged through a secure link sent directly to you. No card data is stored on our servers. Passport and personal documents are encrypted, accessible only to our team, and deleted upon completion of your booking.

Our team is available Monday to Friday, 9 am to 6 pm CET. For urgent matters, including same-day and next-day requirements,  we remain reachable beyond these hours.`,
  },
  {
    id: 'membership',
    label: 'Membership',
    body: `Membership with Mwuïlu is by invitation only. Each new member is personally vetted and brought on board through a direct introduction. There is no open registration.

If you are using this portal, you are already a valued member of our circle. We are honoured by the trust you place in us.`,
  },
]

export default function AboutUs({ onBack }) {
  return (
    <div className="db-page cnt-page cnt-page--wide">

      {/* Header */}
      <div className="cnt-header">
        <button className="cnt-back" onClick={onBack} aria-label="Back">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Dashboard
        </button>
        <div className="cnt-header__title-wrap">
          <p className="cnt-header__overline">Mwuïlu</p>
          <h1 className="cnt-header__title">About</h1>
        </div>
      </div>

      {/* Opening statement */}
      <div className="cnt-about-lead">
        <p className="cnt-about-lead__text">
          Chief Facilitator of Private &amp; Diplomatic Affairs.
        </p>
      </div>

      {/* Content sections */}
      <div className="cnt-about-sections">
        {ABOUT_SECTIONS.map((section, i) => (
          <article
            key={section.id}
            className="cnt-about-section"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <div className="cnt-about-section__label-col">
              <p className="cnt-about-section__label">{section.label}</p>
            </div>
            <div className="cnt-about-section__body-col">
              {section.body.split('\n\n').map((para, j) => (
                <p key={j} className="cnt-about-section__para">{para}</p>
              ))}
            </div>
          </article>
        ))}
      </div>

      {/* Contact block */}
      <div className="cnt-about-contact">
        <div className="cnt-about-contact__rule" aria-hidden="true" />
        <div className="cnt-about-contact__cols">
          <div className="cnt-about-contact__col">
            <p className="cnt-label">Office Hours</p>
            <p className="cnt-about-contact__val">Monday — Friday</p>
            <p className="cnt-about-contact__val">9:00 — 18:00 CET</p>
          </div>
          <div className="cnt-about-contact__col">
            <p className="cnt-label">Urgent Matters</p>
            <p className="cnt-about-contact__val">Available outside office hours</p>
            <a href="tel:+32471xxxxxx" className="cnt-about-contact__link">+32471 xxx xxx</a>
          </div>
          <div className="cnt-about-contact__col">
            <p className="cnt-label">Connect</p>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="cnt-about-contact__link"
              aria-label="Mwuïlu on LinkedIn"
            >
              LinkedIn
            </a>
          </div>
        </div>
      </div>

    </div>
  )
}